import $ from 'jquery';
import { updateTextOnly } from '@/js/modules/update_text_only';
import { parseQuery, queryString } from '@/js/modules/query_params';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function getTrackedTimeCategoryIds() {
    const params = queryString();
    let ids = (params['ids'] || '').split(',');
    if (ids[0] === '' && ids.length === 1) {
      ids = [];
    }
    return new Set(ids);
  }

  function setTrackedTimeCategoryIds(ids) {
    const params = queryString();

    let url = null;
    params['ids'] = Array.from(ids).join(',');

    if (Object.keys(params).length > 0 && $.param(params).length > 0) {
      url = '?' + $.param(params);
    } else {
      url = window.location.pathname;
    }

    window.history.replaceState(null, '', url);
  }

  function updateTrackedTimeCategoriesControls() {
    const selectedCheckboxesLength = $('.checkbox--tracked-time-categories:checked').length;
    const trackedTimeCategoriesCount = $('.data-table__tr').length;
    const totalSelectedTrackedTimeCategories = getTrackedTimeCategoryIds().size;

    if (totalSelectedTrackedTimeCategories > 0) {
      updateTextOnly(
        $('.h-d-button--delete-tracked-time-categories'),
        `Delete (${totalSelectedTrackedTimeCategories})`
      ).removeClass('hide');
      $('.tracked-time-categories-search-form').hide();
    } else {
      $('.h-d-button--delete-tracked-time-categories').addClass('hide');
      $('.tracked-time-categories-search-form').show();
    }

    // check/uncheck the "check all" checkbox based on count
    $('.checkbox--tracked-time-categories-check-all').prop(
      'checked',
      selectedCheckboxesLength === trackedTimeCategoriesCount
    );
  }

  $(document).ready(() => {
    getTrackedTimeCategoryIds().forEach((trackedTimeCategoryId) => {
      $(`.data-table__tr[data-id=${trackedTimeCategoryId}]`)
        .find('.checkbox--tracked-time-categories')
        .prop('checked', true);
    });
    updateTrackedTimeCategoriesControls();
  });

  $(document).on('change', '.checkbox--tracked-time-categories', (e) => {
    const ids = getTrackedTimeCategoryIds();
    const id = String($(e.target).closest('.data-table__tr').data('id'));

    const checked = $(e.target).is(':checked');
    const $tr = $(e.target).parents('.data-table__tr');
    $tr.toggleClass('data-table__tr--checked', checked);

    if ($(e.target).is(':checked')) {
      ids.add(id);
    } else {
      ids.delete(id);
    }
    const newIds = Array.from(ids).join(',');

    $('.pagination a').each(function (index, link) {
      const url = new URL(link.href);
      const params = parseQuery(url.search);
      params['ids'] = newIds;
      url.search = '?' + $.param(params);
      link.href = url.href;
    });

    setTrackedTimeCategoryIds(ids);
    updateTrackedTimeCategoriesControls();
  });

  $(document).on('change', '.checkbox--tracked-time-categories-check-all', (e) => {
    $('.checkbox--tracked-time-categories').prop('checked', $(e.target).prop('checked')).change();

    updateTrackedTimeCategoriesControls();
  });

  $(document).on('click', '.tracked-time-categories-search-form__clear', (e) => {
    const $el = $(e.target);
    $el.siblings('.tracked-time-categories-search-form__field').val('');
    $el.parents('.tracked-time-categories-search-form').submit();
  });
});
